export const designs = [{
    text1: "Not sure where to begin in the search for the ",
    text2: "Perfect Home?",
    text3: "Start Here",
    text4: "by matching with a local realtor!",
    creative: "start-here",
    button: "Call now",
},{
    text1: "Looking for your",
    text2: "Dream Home?",
    text3: "Get in touch with a local realtor.",
    text4: "",
    creative: "dream-home",
    button: "Call now",
},{
    text1: "Find the perfect",
    text2: "Spot!",
    text3: "Local realtors know the area best - ",
    text4: "Let us match you with one today!",
    creative: "find-the-spot",
    button: "Call now",
},{
    text1: "Get your new home",
    text2: "",
    text3: "With the help of ",
    text4: "a Local Agent",
    creative: "get-your-new-home",
    button: "Call today!",
},{
    text1: "Get matched with a",
    text2: "Local Realtor",
    text3: "Find your",
    text4: "Dream Home",
    creative: "step1-step2",
    button: "Call today!",
    }]